<script>
import toasts from "../../mixins/toasts";
import Survey from "../../Survey";

export default Vue.extend({
  props: {
    preset: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      offsetTimes: [
        {
          value: 15,
          unit: "minutes"
        },
        {
          value: 30,
          unit: "minutes"
        },
        {
          value: 1,
          unit: "hour"
        },
        {
          value: 6,
          unit: "hours"
        },
        {
          value: 24,
          unit: "hours"
        }
      ],
      publishModal: {
        sendNotification: true,
        active: false,
        errors: {
          time: false
        },
        startDate: null,
        startTime: null,
        date: null,
        time: null
      },
      notifyModal: {
        active: false
      },
      sessionDuration: {
        current: 0,
        target: 0,
        label: null
      },
      survey: this.preset
    };
  },
  mixins: [toasts],
  components: { Survey },
  computed: {
    sessionDurationWarning() {
      return false;
    },
    sessionDurationDanger() {
      return this.sessionDuration.current / this.sessionDuration.target >= 0.75;
    },
    durationText() {
      return this.$moment(this.datetime).from(
        this.$moment(this.publishModal.startDatetime)
      );
    },
    startDatetime() {
      if (!this.publishModal.startDate || !this.publishModal.startTime) {
        return new Date();
      }

      let date = this.$moment(this.publishModal.startDate);
      let time = this.$moment(this.publishModal.startTime);

      let datetime = date.toDate();

      datetime.setHours(this.publishModal.startTime.getHours());
      datetime.setMinutes(this.publishModal.startTime.getMinutes());

      return datetime;
    },
    datetime() {
      if (!this.publishModal.date || !this.publishModal.time) {
        return new Date();
      }

      let date = this.$moment(this.publishModal.date);
      let time = this.$moment(this.publishModal.time);

      let datetime = date.toDate();

      datetime.setHours(this.publishModal.time.getHours());
      datetime.setMinutes(this.publishModal.time.getMinutes());

      return datetime;
    },
    startTimeText() {
      return this.$moment(this.startDatetime).calendar();
    },
    endTimeText() {
      return this.$moment(this.datetime).calendar();
    },
    publishModalErrors() {
      let error = false;

      _.each(this.publishModal.errors, err => {
        if (err) {
          error = true;
          return false;
        }
      });

      return error;
    }
  },
  mounted() {
    this.$refs.taskbar.hide();
  },
  methods: {
    updateTaskbar(data) {
      this.sessionDuration = data.duration;

      if (this.$refs.taskbar != null) {
        Vue.nextTick(() => {
          this.$refs.taskbar.hide(data.hidden || data.duration.delta < 1);
        });
      }
    },
    updateErrors() {
      this.publishModal.errors.startTime = this.publishModal.errors.time = this.$moment(
        this.startDatetime
      ).isAfter(this.datetime);
    },
    onTimeUpdate() {
      this.updateErrors();
    },
    onStartDurationClick(value, unit) {
      // Reset date and apply time offset.
      this.publishModal.startDate = this.publishModal.startTime = this.$moment()
        .add(value, unit)
        .toDate();
    },
    onDurationClick(value, unit) {
      // Reset date and apply time offset.
      this.publishModal.date = this.publishModal.time = this.$moment(
        this.startDatetime
      )
        .add(value, unit)
        .toDate();
    },
    onDateUpdate() {
      this.publishModal.startDate.setHours(
        this.publishModal.startTime.getHours()
      );
      this.publishModal.startDate.setMinutes(
        this.publishModal.startTime.getMinutes()
      );
      this.publishModal.date.setHours(this.publishModal.time.getHours());
      this.publishModal.date.setMinutes(this.publishModal.time.getMinutes());
      this.updateErrors();
    },
    beforeNotify() {
      this.notifyModal.active = true;
    },
    notify() {
      let loading = this.$loading.open();

      axios
        .post(`/api/surveys/${this.survey.id}/notify`)
        .then(response => {
          this.notifyModal.active = false;
          this.toast("success", "Уведомления отправлены");
        })
        .catch(error => {
          switch (error.response.status) {
            case 429: {
              let minutes = _.get(error.response.data, "minutes");
              this.toast(
                "info",
                `Нельзя отправлять уведомления чаще, чем один раз в ${minutes} минут`
              );
              break;
            }
            default: {
              this.toast("error", "@unexpected", error);
            }
          }
        })
        .finally(_ => {
          loading.close();
        });
    },
    beforePublish() {
      if (this.survey.scope.length == 0) {
        this.toast("warning", "Необходимо указать участников");
        return;
      } else if (this.survey.questions.length == 0) {
        this.toast("warning", "Необходимо создать хотя бы один вопрос");
        return;
      }

      this.publishModal.startDate = this.publishModal.startTime = this.$moment().toDate();
      let offset = _.first(this.offsetTimes);
      this.publishModal.date = this.publishModal.time = this.$moment()
        .add(offset.value, offset.unit)
        .toDate();

      this.publishModal.sendNotification = true;

      this.publishModal.active = true;
    },
    publish() {
      let loading = this.$loading.open();

      this.survey.published = true;
      this.survey.start_at = this.$moment(this.startDatetime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.survey.end_at = this.$moment(this.datetime).format(
        "YYYY-MM-DD HH:mm:ss"
      );

      axios
        .put(`/api/surveys/${this.survey.id}`, this.survey, {
          params: {
            notify: this.publishModal.sendNotification
          }
        })
        .then(response => {
          this.publishModal.active = false;
          this.toast(
            "success",
            this.survey.is_quiz ? "Тест опубликован" : "Анкета опубликована"
          );
        })
        .catch(error => {
          this.toast("error", "@unexpected", error);
        })
        .finally(_ => {
          loading.close();
        });
    },
    unpublish() {
      this.$dialog.confirm({
        title: this.survey.is_quiz ? "Скрытие теста" : "Скрытие анкеты",
        message:
          (this.survey.is_quiz
            ? `Вы уверены, что хотите скрыть этот тест?`
            : `Вы уверены, что хотите скрыть эту анкету?`) +
          `<br>Все ранее отправленные ответы будут удалены.`,
        confirmText: "Скрыть",
        cancelText: "Отмена",
        type: "is-warning",
        hasIcon: true,
        onConfirm: () => {
          let loading = this.$loading.open();

          this.survey.published = false;

          axios
            .put(`/api/surveys/${this.survey.id}`, this.survey)
            .then(response => {
              this.toast(
                "success",
                this.survey.is_quiz ? "Тест скрыт" : "Анкета скрыта"
              );
            })
            .catch(error => {
              this.toast("error", "@unexpected", error);
            })
            .finally(_ => {
              loading.close();
            });
        }
      });
    },
    duplicate() {
      let loading = this.$loading.open();

      axios
        .post(`/api/surveys/${this.survey.id}/duplicate`)
        .then(response => {
          _.delay(() => {
            window.open(`${response.data.url}/edit`, "_self");
          }, 2000);
        })
        .catch(error => {
          loading.close();
          this.toast("error", "@unexpected", error);
        });
    },
    remove() {
      this.$dialog.confirm({
        title: this.survey.is_quiz ? "Удаление теста" : "Удаление анкеты",
        message: this.survey.is_quiz
          ? `Вы уверены, что хотите удалить этот тест?`
          : `Вы уверены, что хотите удалить эту анкету?`,
        confirmText: "Удалить",
        cancelText: "Отмена",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          let loading = this.$loading.open();

          axios
            .delete(`/api/surveys/${this.survey.id}`)
            .then(response => {
              this.toast(
                "success",
                this.survey.is_quiz
                  ? "Тест был успешно удален"
                  : "Анкета была успешно удалена"
              );
              _.delay(() => {
                window.open(
                  this.survey.is_quiz ? "/quizzes" : "/surveys",
                  "_self"
                );
              }, 2000);
            })
            .catch(error => {
              this.toast("error", "@unexpected", error);
              loading.close();
            });
        }
      });
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/surveys/Show.vue